export default __webpack_public_path__ + "static/media/640_business04-en-web.3918e827.png";